import { takeEvery } from 'redux-saga/effects'
import { TRANSFER_CHAT_SAGA } from 'src/store/types/appControl'
import fetchTransferChat from './fetchTransferChat'

export function* transferChatSaga() {
  yield takeEvery(TRANSFER_CHAT_SAGA, fetchTransferChat)
}
